export type RelaySessionKind = 'manual' | 'instance' | 'peer-runner';

/** Enriched relay session as returned by GET /api/relay/sessions[/:id]. */
export interface RelaySession {
  id: string;
  tag: string | null;
  kind: RelaySessionKind;
  active: boolean;
  /** Monotonic event counter (spawn/command/chat traffic) — not a human message count. */
  seq: number;
  /** Sockets currently joined to this session's room. */
  liveConnections: number;
  /** Whether the server holds a data encryption key for at-rest ciphertext. */
  encrypted: boolean;
  lastActiveAt: string;
  createdAt: string;
  updatedAt: string;
}

/** Aggregate relay metrics from GET /api/relay/metrics. */
export interface RelayMetrics {
  activeSessions: number;
  totalMessages: number;
  avgSessionAgeMs: number;
}

export const RELAY_KIND_LABELS: Record<RelaySessionKind, string> = {
  manual: 'Manual',
  instance: 'Instance',
  'peer-runner': 'Peer runner',
};
